export default {
  getKeywordAlternative: (state) => state.keywordAlternative,
};
